import { memo } from 'react';
import { makeStyles } from '@coreai/fluentui-react';
import { Handle, Position, type Node } from '@xyflow/react';
import { useIsHorizontalLayout } from '@/hooks/useLayoutOrientation';

export type PhantomNodeData = {
  label?: string;
};

export type PhantomNodeType = Node<PhantomNodeData, 'phantom'>;

const useStyles = makeStyles({
  container: {
    width: '1px',
    height: '1px',
    opacity: 0,
  },
  handle: {
    opacity: 0,
  },
});

/**
 * Invisible phantom node used as target for terminal edges
 * This node is completely invisible but provides connection points
 */
export const PhantomNode = memo(function PhantomNode() {
  const isHorizontal = useIsHorizontalLayout();
  const styles = useStyles();

  // Handle position should match the direction of the edge
  // Horizontal: edge comes from right, handle on left
  // Vertical: edge comes from bottom, handle on top
  const handlePosition = isHorizontal ? Position.Left : Position.Top;

  return (
    <div className={styles.container}>
      <Handle
        type="target"
        position={handlePosition}
        id="input"
        className={styles.handle}
      />
    </div>
  );
});
